import { bareboneBlueprint } from "@made-people/blueprint-header/blueprint";

bareboneBlueprint.main.override({
  slots: {
    // wrapper:
    //   "group transition-[height] duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] w-full has-[.active-submenu]:hover:[--foreground:black] has-[.active-submenu]:hover:[--background:white] data-[scrolled=true]:shadow-[0_1px_0_0_rgba(0,0,0,0.05)]",
    // nav: "relative flex gap-4 justify-between h-full md:px-component-spacing-lg lg:px-component-spacing-3xl duration-300 lg:py-4 group-data-[scrolled=true]:lg:py-2 bg-[--background]",
    wrapper:
      "w-full group bg-[--background] has-[.active-submenu]:hover:[--foreground:theme(colors.black)] has-[.active-submenu]:hover:[--background:theme(colors.background.page)] data-[scrolled=true]:shadow-[0_1px_0_0_rgba(0,0,0,0.05)]",
    nav: "static flex items-center h-10 py-4 group/nav px-component-spacing-xs md:px-component-spacing-md lg:px-component-spacing-md max-w-component-max-w-xl box-content mx-auto",
    menuPosition: "order-first max-w-[45%]",
    logoPosition:
      "order-2 absolute left-1/2 top-[calc(50%+16px)] -translate-x-1/2 -translate-y-1/2 h-12 group-first/nav:top-1/2",
    cartTriggerPosition: "order-last -mr-2 ml-3",
    accountTriggerPosition: "order-3",
    siteSettingsTriggerPosition:
      "order-4 pr-4 text-label-md text-[--foreground] font-primary whitespace-nowrap",
    searchTriggerPosition: "order-5 ml-auto",
    topbarPosition: "",
  },
  variants: {
    color: {
      white: {
        wrapper:
          "[--foreground:theme(colors.black)] [--background:theme(colors.background.page)]",
      },
      transparent: {
        wrapper:
          "[--foreground:theme(colors.white)] data-[scrolled=true]:[--background:theme(colors.background.page)] before:absolute before:w-full before:h-[100%] before:transition-opacity before:bg-white/0 before:bg-gradient-to-b before:from-black/30 before:-z-20 data-[scrolled=true]:before:bg-none data-[scrolled=true]:before:hidden data-[scrolled=true]:[--foreground:theme(colors.black)]",
      },
    },
  },
  defaultVariants: {
    color: "transparent",
  },
});

bareboneBlueprint.cartTrigger.override({
  slots: {
    wrapper: "flex gap-2 items-center relative",
    counter:
      "w-4 h-4 flex justify-center items-center rounded-full text-[10px] bg-[--foreground] text-[--background] absolute top-1 right-0 font-medium",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[18px] [&>svg]:fill-[--foreground]",
    label: "",
  },
});

bareboneBlueprint.accountTrigger.override({
  slots: {
    wrapper: "flex gap-2 items-center",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[15px] [&>svg]:h-[18px] [&>svg]:fill-[--foreground]",
    label: "",
  },
});

bareboneBlueprint.searchTrigger.override({
  slots: {
    wrapper: "flex gap-0 items-center",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[19px] [&>svg]:h-[19px] [&>svg]:mt-0.5  [&>svg]:fill-[--foreground]",
    label: "",
  },
});

bareboneBlueprint.logo.override({
  slots: {
    wrapper: "flex justify-start items-center shrink-0",
    link: "flex justify-start items-center w-full h-full active:translate-y-0.5 transition-transform [&>svg]:fill-[--foreground]",
  },
});
